module.exports = __webpack_public_path__ + "static/media/DoubleArrow.52f81366.svg";